<template>
  <div>
    <vx-card class="mt-base" :title="activityTitle">
      <p class="mb-5">You will need: Boxes and bags of various sizes and weights</p>
      <p class="mb-5">
        No matter what role you have in the construction industry, the chances are that one of the
        main risks you’ll face will be from putting your body under stress and strain.
      </p>
      <p class="mb-5">
        You’ll be lifting, handling, and carrying heavy objects at one time or another. Back injury
        is one of the greatest risks that construction workers face - especially, but not only,
        those in the trades.
      </p>
      <p class="mb-5">
        Situations that you may encounter where you’ll be at risk of injury include:
      </p>
      <ul class="default-list">
        <li>Supporting loads, often while in an awkward position</li>
        <li>Moving heavy objects and materials</li>
        <li>Carrying loads over rough, uneven ground</li>
        <li>Undertaking repetitive tasks for long periods.</li>
      </ul>
      <p class="mb-5">
        Situations such as those outlined above create stress and strain within the body that can
        cause damage to muscles and tendons. Repeated stresses and strains on the body can lead to
        longer-term and recurrent problems.
      </p>
      <p class="mb-5">
        Back injuries and upper limb injuries are some of the most common causes of workplace
        absences. Not only are these injuries damaging to our health, but they can also be damaging
        to our wallets too!
      </p>
      <p class="mb-5">
        Luckily, many of these types of injuries can be prevented by learning proper lifting and
        carrying techniques.
      </p>
      <p class="mb-5">
        In the videos below, you’ll learn some proper lifting techniques and hear some tips to help
        you minimise the chance of injury.
      </p>
      <p class="mb-5"><strong>Video #1: Lifting Objects at Work</strong></p>

      <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1" />
      <p class="mb-5"><strong>Video #2: Top 10 Lifting Rules</strong></p>

      <responsive-youtube-wrapper :video="videos[2]" :image="videoTrigger2" />
      <h4 class="mb-5">Post-Video Activity</h4>
      <p class="mb-5">
        There was lots of useful information on how to lift correctly. One way to ensure you have
        good form when you lift objects on site is to practise the techniques described in the
        videos.
      </p>
      <p class="mb-5">
        Just as athletes isolate techniques from their sports to drill repeatedly, we can practise
        lifting with proper form at home.
      </p>
      <p class="mb-5">
        First, you’ll need to find some objects to lift. Gather up some boxes of various shapes and
        sizes at home to practice with. Empty ones are perfect. In the beginning, you don’t want to
        put any strain on your body. You want to make sure your lifting technique is perfect first.
      </p>

      <div class="vx-row my-5 flex items-center justify-center">
        <div class="vx-col xl:w-2/3 lg:w-2/3 w-full my-5">
          <p class="mb-5">
            When you’re ready to practise lifting, use the basic lift. This technique is outlined in
            the <strong>Top Tips: Proper Lifting Technique</strong> PDF document - use this for
            reference (click on the image on the right to download this).
          </p>
          <p class="mb-5">
            Make sure you do plenty of reps practising the technique until you can do each part of
            the lift perfectly. You can then start to lift slightly heavier objects - but not too
            heavy! Proper form is more important than the weight lifted at this stage.
          </p>
        </div>
        <div class="vx-col xl:w-1/3 lg:w-1/3 w-full my-5">
          <a :href="'content/construction/proper_lifting_technique.pdf' | blob_url" target="_blank">
            <img
              src="@/assets/images/experiences/construction/lifting_technique_button.jpg"
              alt="Read the proper lifting technique guide (PDF, opens in a new tab)"
              class="mx-auto img-responsive"
            />
          </a>
        </div>
      </div>

      <p class="mb-5">
        When you have mastered the basic lift. Try lifting other objects (e.g. suitcases, sports
        bags, fertiliser bags, etc).
        <span style="color: #e90000">Do not lift anything more than 10kg in this task.</span>
      </p>
      <p class="mb-5">
        Then try lifting objects using the other lifts described in <strong>Video #1</strong>:
      </p>
      <ul class="default-list">
        <li>The Power Lift</li>
        <li>The Tripod Lift</li>
        <li>The Partial Squat Lift</li>
      </ul>
      <p class="mb-5">
        Not only will these lifts help you avoid injury on building sites, but they’ll help keep you
        safe in your daily life too!
      </p>

      <h4 class="mb-5">Your Task:</h4>
      <p class="mb-5">
        Take a photo or a video of yourself lifting an object and showing a correct lifting
        technique. Upload this photo/video below.
      </p>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="media"
        index="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/construction/activity_21.jpg'),
      videoTrigger2: require('@/assets/images/experiences/construction/activity_22.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/qP5nyfTDbfE',
        2: 'https://www.youtube.com/embed/LaFoZR3gd44',
      },
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
